import { render, staticRenderFns } from "./archival-table-row.vue?vue&type=template&id=5e5c79e3"
import script from "./archival-table-row.vue?vue&type=script&lang=js"
export * from "./archival-table-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports